var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2002 10.7999H0.700195C0.700195 11.0761 0.924053 11.2999 1.2002 11.2999V10.7999ZM1.7002 1.19995C1.7002 0.923809 1.47634 0.699951 1.2002 0.699951C0.924053 0.699951 0.700195 0.923809 0.700195 1.19995H1.7002ZM10.8002 11.2999C11.0763 11.2999 11.3002 11.0761 11.3002 10.7999C11.3002 10.5238 11.0763 10.2999 10.8002 10.2999V11.2999ZM3.9279 3.82231C3.71933 3.64133 3.40354 3.66368 3.22255 3.87225C3.04157 4.08081 3.06393 4.39661 3.27249 4.57759L3.9279 3.82231ZM5.80017 6.109L5.47247 6.48664C5.66048 6.64979 5.93986 6.64979 6.12787 6.48664L5.80017 6.109ZM7.37159 4.74539L7.69929 4.36775C7.51128 4.20461 7.23189 4.20461 7.04388 4.36775L7.37159 4.74539ZM9.87249 7.57759C10.0811 7.75857 10.3968 7.73622 10.5778 7.52765C10.7588 7.31909 10.7365 7.00329 10.5279 6.82231L9.87249 7.57759ZM1.7002 10.7999V1.19995H0.700195V10.7999H1.7002ZM1.2002 11.2999H10.8002V10.2999H1.2002V11.2999ZM3.27249 4.57759L5.47247 6.48664L6.12787 5.73136L3.9279 3.82231L3.27249 4.57759ZM6.12787 6.48664L7.69929 5.12303L7.04388 4.36775L5.47247 5.73136L6.12787 6.48664ZM7.04388 5.12303L9.87249 7.57759L10.5279 6.82231L7.69929 4.36775L7.04388 5.12303Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsIcon);
export default __webpack_public_path__ + "static/media/stats-icon.5aaa97a53f928e847f28e6a025829bdc.svg";
export { ForwardRef as ReactComponent };